import { CallbackObject } from 'api/core/get-page-function';
import { GetPickingsVm } from './get-pickings.vm';
import { OrderPickingStatus } from './picking.vm';
import { plainToClass } from 'class-transformer';
import { instance } from 'api/core';
import { AxiosResponse } from 'axios';

export const getPickings = async (
    offset: string,
    status: OrderPickingStatus | null,
    customerId: string | null,
    orderId: string | null,
    pickerId: string | null,
    warehouseId: string | null,
    callback: CallbackObject<GetPickingsVm>
) => {
    const config: Record<string, any> = {
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
            limit: 50,
            offset: offset,
        },
    };

    if (status) {
        config.params.status = status;
    }

    if (customerId) {
        config.params.customerId = customerId;
    }

    if (orderId) {
        config.params.orderId = orderId;
    }

    if (pickerId) {
        config.params.pickerId = pickerId;
    }

    if (warehouseId) {
        config.params.warehouseId = warehouseId;
    }

    try {
        const res: AxiosResponse = await instance.get(`/picking/pickings`, config);
        callback.success(plainToClass(GetPickingsVm, res.data));
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
